module.exports = __webpack_public_path__ + "img/stop_btn.d179145f.png";